import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

const styles = theme => ({
    etlProgressDialog:{
        width:"470px",
        height:"352px",
        textAlign:"center",
        padding:"22px",
        boxSizing: "border-box",
        borderRadius:"2px",
        backgroundColor: theme.ModalBGColor,
        boxShadow: "2px 2px 4px black"
    },
    etlProgressImg:{
        width:"242px",
        height:"242px",
        display: 'flex',
        margin: 'auto',
        paddingTop: "10px"
    },
    etlProgressTitle:{
        fontSize:16,
        fontWeight:"600",
        lineHeight:"22px",
        color: theme.HeaderSelectedText,
        padding:"0px",
        paddingBottom:"16px"
    },
    etlProgressContent:{
        fontSize:"12px",
        lineHeight:"17px",
        overflow:"hidden",
        color: theme.TextColor,
    },
})

const ETLProgressDialog = props => {
    const {classes, show, planDate, theme} = props;
        return(
            <Dialog
            open={show}
            classes={{paper:classes.etlProgressDialog}}
            aria-labelledby="etl-progress">
                <DialogTitle 
                disableTypography={true} 
                classes={{root:classes.etlProgressTitle}} 
                id="etl-progress">
                Loading New Data
                </DialogTitle>
                <DialogContent className={classes.etlProgressContent}>
                    <div>Data for {planDate} plan date will be ready soon!</div>
                    <img 
                    className={classes.etlProgressImg} 
                    src={theme==="dark"?"../../../images/ETLProgress_Dark.gif":"../../../images/ETLProgress_Light.gif"}/>
                </DialogContent>
            </Dialog>
        )
}

export default withStyles(styles)(ETLProgressDialog)